exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2uJAL{border:1px dashed #ddd;padding:16px;padding:1rem;clear:both;background-color:#f4f4ec}@media screen and (min-width:768px){._2uJAL{padding:1.5rem 2rem}}.mhnzC{margin-bottom:16px;margin-bottom:1rem}.mhnzC i,.mhnzC small,.mhnzC span{display:block}.mhnzC span{font-size:1.25em;font-weight:500}.mhnzC small{font-size:.875em}@media screen and (min-width:768px){.mhnzC{text-align:center}}", ""]);

// exports
exports.locals = {
	"root": "_2uJAL",
	"head": "mhnzC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Information/Information.css
// module id = 676
// module chunks = 0 1